import { PHeading } from "@porsche-design-system/components-react"
import type { InventoryAndIntakeView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { Date, List } from "src/components"

const messages = defineMessages({
	arrivalDate: {
		defaultMessage: "Intake date",
		id: "vehicleDetails.overview.inventory.intakeDate",
	},
	availableForCustomerFromDate: {
		defaultMessage: "Customer Availability Date",
		id: "vehicleDetails.overview.inventory.availableForCustomerFromDate",
	},
	intakeType: {
		defaultMessage: "Intake type",
		id: "vehicleDetails.overview.inventory.intakeType",
	},
	mileageAccordingToPreviousOwner: {
		defaultMessage: "Mileage according to previous owner",
		id: "vehicleDetails.overview.inventory.mileageAccordingToPreviousOwner",
	},
	purchasePriceNet: {
		defaultMessage: "Purchase price net",
		id: "vehicleDetails.overview.inventory.purchasePrice",
	},
	sourceInformation: {
		defaultMessage: "Source information",
		id: "vehicleDetails.overview.inventory.list.sourceInformation.title",
	},
})

interface IntakeInformationListProps {
	view: InventoryAndIntakeView
}

export const IntakeInformationList = ({ view }: IntakeInformationListProps) => {
	const { formatMessage } = useIntl()
	return (
		<List
			header={
				<PHeading size="sm">
					<FormattedMessage {...messages.sourceInformation} />
				</PHeading>
			}
		>
			<List.Item label={formatMessage(messages.arrivalDate)} value={view.arrivalDate} />
			{view.inventoryStatus.availabilityDate && (
				<List.Item
					label={view.inventoryStatus.availabilityDate.label}
					value={<Date weight="semibold" view={view.inventoryStatus.availabilityDate.date} />}
				/>
			)}
			<List.Item
				label={formatMessage(messages.availableForCustomerFromDate)}
				value={<Date weight="semibold" view={view.availableForCustomerFromDate} />}
			/>
			<List.Item label={formatMessage(messages.intakeType)} value={view.vehicleOrigin} />
			<List.Item
				label={formatMessage(messages.mileageAccordingToPreviousOwner)}
				value={view.mileageAccordingToPreviousOwner}
			/>
		</List>
	)
}
